import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';

// Material Modules
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { AutoSizeInputDirective } from "ngx-autosize-input";

// Modules
import { ElementsModule } from '@modules/elements/elements.module';
import { TasksModule } from '@modules/tasks/tasks.module';

// Components
import { SelectProjectComponent } from './components/select-project/select-project.component';
import { ProjectDetailsComponent } from './components/project-details/project-details.component';
import { CreateProjectComponent } from './components/create-project/create-project.component';
import { ProjectServerComponent } from './components/project-server/project-server.component';
import { CreateDestinationComponent } from './components/create-destination/create-destination.component';
import { StationsListComponent } from './components/stations-list/stations-list.component';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    OverlayModule,

    // Material
    MatIconModule,
    MatDialogModule,
    MatCheckboxModule,
    MatMenuModule,
    AutoSizeInputDirective,

    ElementsModule,
    TasksModule,
  ],
  declarations: [
    SelectProjectComponent,
    ProjectDetailsComponent,
    CreateProjectComponent,
    ProjectServerComponent,
    CreateDestinationComponent,
    StationsListComponent,
  ],
  exports: [
    SelectProjectComponent
  ]
})
export class ProjectModule { }
